import { toDateString } from "./to-date"

export const getAnoMes = (date: Date) => {
    const getDate = toDateString(date, 'yyyy-MM')
    return Number(getDate?.replace('-', '') ?? '')
}